import { useEffect, useRef } from 'react';

export function Background() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current!;
    const ctx = canvas.getContext('2d')!;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particlesArray: Particle[] = [];
    const colors = ['#151515'];
    const image = new Image;

    class Particle {
      constructor(
        public x: number,
        public y: number,
        public size: number,
        public color: string,
        public velocityX: number,
        public velocityY: number
      ) {}

      update() {
        this.x += this.velocityX;
        this.y += this.velocityY;

        if (this.x < 0 || this.x > canvas.width) this.velocityX *= -1;
        if (this.y < 0 || this.y > canvas.height) this.velocityY *= -1;
      }

      draw() {
        ctx.drawImage(image, this.x, this.y, this.size, this.size);
      }
    }

    function initParticles(count: number) {
      for (let i = 0; i < count; i++) {
        const size = Math.random() > 0.5 ? 128 : 96;
        const x = Math.random() * canvas.width;
        const y = Math.random() * canvas.height;
        const color = colors[Math.floor(Math.random() * colors.length)];
        const velocityX = (Math.random() - 0.5) * 6;
        const velocityY = (Math.random() - 0.5) * 6;

        particlesArray.push(new Particle(x, y, size * 1.5, color, velocityX, velocityY));
      }
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particlesArray.forEach((particle) => {
        particle.update();
        particle.draw();
      });

      setTimeout(animate, 1000 / 30);
    }

    window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      particlesArray.length = 0;
      initParticles(20);
    });

    image.onload = function(){
      initParticles(20);
      animate();
    };
    image.src = 'assets/backgrounds/square.avif';

    return () => {
      window.removeEventListener('resize', () => {});
    };
  }, []);

  return (
    <>
      <canvas className="absolute inset-0 object-cover w-full h-full scale-125 overflow-hidden" ref={canvasRef} />
      <div className="absolute inset-0 background-overlay" />
    </>
  );
}